module.exports = __webpack_public_path__ + "static/media/a8-header-logo.459e2363.svg";